import { sponsorAxiosInstance } from "./base-service";
import { AxiosResponse } from "axios";

export const AgreedToTerms = (): Promise<AxiosResponse<void>> => {
    return sponsorAxiosInstance.put<void>("/v1/User/AgreedToTerms");
};